import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Spacer, spacerAlignItems } from '@amzn/dvui/dist/Spacer'
import { Text } from '@amzn/dvui/dist/Text'
import { BtfMorePurchaseOptions } from '../morePurchaseOptions/btfMorePurchaseOptions'
import { Refund } from '../refund/refund'
import { Acquisition } from '../acquisition/acquisition'
import { flattenArray, isEmpty } from '../../utils/utils'
import { getTvodWinnersChildren, getTvodWinnersMetadata } from '../../selectors/acquisitionActions'
import { TvodButtonScope } from '../acquisition/tvodButton'
import { DisableOverlay } from './disableOverlay'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as st from './actionBox.module.scss'
import * as cn from 'classnames'
import { AdjustHeightForContent } from '../../utils/AdjustHeightForContent'
import { RequestContext } from '@utils'
import { GiftCardModal } from '../giftCard/giftCardModal'
import { ActionBoxComponentState } from '../../widgets/Atf/actionBox'

export type ActionBoxProps = {
  titleID: string
  notificationActions?: WpsRuntime.atv.wps.NotificationActionProps[]
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModelProps
  sequenceNumber?: number
  isPurchasing: boolean
  isRefunding: boolean
  useNodeGiftCard?: boolean
  rawContext?: RequestContext
}

type TvodWinnerMessagesType = {
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModelProps
}

const TvodWinnersMessages = ({
  acquisitionActions
}: TvodWinnerMessagesType) => {
  if (!acquisitionActions) {
    return null
  }

  // In order keep the btf card short, we print only the tvodWinners metadata messages if they are available. Otherwise,
  // we print the messages of all the tvodWinners
  const tvodWinnerMetadata = getTvodWinnersMetadata(acquisitionActions.tvodWinners)
  const tvodMessages = tvodWinnerMetadata.length > 0 ?
    tvodWinnerMetadata.map((msg, idx) => <Text key={idx} string={msg} />) :
    flattenArray(
      getTvodWinnersChildren(acquisitionActions.tvodWinners)
        .filter(action => !isEmpty(action.displayMessages))
        .map((action, outerIdx) =>
          action.displayMessages.map((message, innerIdx) => <Text key={`${outerIdx},${innerIdx}`} string={message} />)))

  return !isEmpty(tvodMessages) ? (
    <Spacer alignItems={spacerAlignItems.stretch}>{tvodMessages}</Spacer>
  ) : null
}


export class ActionBox extends React.Component<ActionBoxProps, ActionBoxComponentState> {

  constructor(props: ActionBoxProps) {
    super(props)
    this.state = { giftCardModalIsVisible: false }
  }

  openGiftCardModal = () => {
    this.setState({ giftCardModalIsVisible: true })
  }

  closeGiftCardModal = () => {
    this.setState({ giftCardModalIsVisible: false })
  }

  render() {
    const {
      acquisitionActions,
      titleID,
      sequenceNumber,
      isPurchasing,
      isRefunding,
      useNodeGiftCard,
      rawContext
    } = this.props

    const moreWaysToWatch =
      acquisitionActions && acquisitionActions.moreWaysToWatch

    const isProcessingTransaction = isPurchasing || isRefunding

    return (
      <div className={cn({[st.isProcessingTransaction]: isProcessingTransaction}, st.wrapper)}>
        <AdjustHeightForContent>
          <TvodWinnersMessages acquisitionActions={acquisitionActions}/>
          <Spacer alignItems={spacerAlignItems.stretch}>
            <div className={cn(st.acquisition, utilityClasses.fullWidthPhablet)}>
              <Acquisition
                acquisitionActions={acquisitionActions}
                titleId={titleID}
                tvodButtonScope={TvodButtonScope.EPISODE_LIST}
                forceDoubleHeight={false}
              />
            </div>
            <BtfMorePurchaseOptions
              titleId={titleID}
              sequenceNumber={sequenceNumber}
              moreWaysToWatch={moreWaysToWatch}
              openGiftCardModal={this.openGiftCardModal}
            />
            <Refund titleId={titleID}/>
          </Spacer>
          {isProcessingTransaction && <DisableOverlay/>}
        </AdjustHeightForContent>
        {useNodeGiftCard && <GiftCardModal isOpen={this.state.giftCardModalIsVisible}
                                           onClose={this.closeGiftCardModal}
                                           requestContext={rawContext}/>}
      </div>
    )
  }
}
